{
  "version": 1,
  "asset_id": "443ee21e-7af2-44c1-84a6-fc4153d25cde",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/443ee21e-7af2-44c1-84a6-fc4153d25cde/ascended-and-armed-cover.png",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/443ee21e-7af2-44c1-84a6-fc4153d25cde/ascended-and-armed-cover.png",
  "original_filename": "ascended-and-armed-cover.png",
  "size": 2879072,
  "content_type": "image/png",
  "created_at": "2026-07-15T00:40:26Z"
}
